module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "card",
    class: {
      'center-content': _vm.center
    }
  }, [(_vm.hasHeader()) ? _c('div', {
    staticClass: "header",
    class: {
      'header-icon': _vm.icon != null
    }
  }, [(_vm.icon) ? _c('span', {
    staticClass: "icon",
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.headline) ? _c('div', {
    staticClass: "headline pull-left",
    class: {
      oneHeadline: !_vm.description
    }
  }, [_vm._v("\n            " + _vm._s(_vm._f("capitalize")(_vm.headline)) + "\n\n            "), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._t("header")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    class: {
      'center-me': _vm.center
    }
  }, [_c('div', [_vm._t("default")], 2)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-871b98b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Card.vue
// module id = 404
// module chunks = 1